import axios from 'axios'
import store from '@/store/store'

export async function getAndAnalysisData() {
  axios
    // fake data for development
    // .get('http://localhost:8080/api')
    .get('/gra2021/')
    .then((res) => {
      // console.log(res.data)
      store.commit('writeData', { data: res.data })
      // let _sort = res.data.data._sort
      // 针对没有早课的情况做处理
      // if (res.data.data.Schedule.MorningClass.ThisTerm !== 0) {
      //   _sort.push('Morning')
      // }
      store.commit('changeShowPage', {
        sort: res.data.data._sort,
      })
      store.commit('LoadingDone')
    })
    .catch((err) => {
      console.log(err.response)
      store.commit('errorHappened', { error: err.response.status })
    })
}

export async function axiosInit() {
  axios.defaults.baseURL = 'https://api.hduhelp.com'
  // axios.defaults.baseURL = 'http://localhost:11451'
  const token = localStorage.getItem('hduHelp/token')
  // await initToken()
  if (token) {
    axios.defaults.headers.common.Authorization = `token ${token}`
    // await initToken()
  } else {
    // axios.defaults.headers.common.Authorization = `token ${token}`
    await initToken()
  }
}

// 从重定向回来的URL中获得auth token
function getAuth() {
  const query = window.location.search.substring(1)
  const vars = query.split('&')
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=')
    if (pair[0] === 'auth') {
      return pair[1]
    }
  }
  return false
}

async function initToken() {
  const token = localStorage.getItem('hduHelp/token')
  if (token) {
    axios.defaults.headers.common.Authorization = `token ${token}`
  } else if (token === null && getAuth() !== false) {
    const token = getAuth()
    localStorage.setItem('hduHelp/token', token)
    axios.defaults.headers.common.Authorization = `token ${token}`
    window.location.href = window.location.origin
  } else {
    await axios
      .get('login/url/cas', {
        params: {
          clientID: 'annualsummary',
          redirect: `${window.location.origin}`,
        },
      })
      .then((data) => {
        const redirectURL = data.data.data.url
        window.location.href = redirectURL
      })
      .catch((err) => {
        store.commit('errorHappened', { error: err })
      })
  }
}
